/**
 * Shared module for vertical override state.
 *
 * This allows service modules (which can't access React context)
 * to include the active vertical override in API requests.
 *
 * The UserContext sets this value when activeVertical changes,
 * and API services read it to append the `vertical` query param.
 */

let _activeVertical = null;

export function setVerticalOverride(vertical) {
  _activeVertical = vertical || null;
}

export function getVerticalOverride() {
  return _activeVertical;
}
